import React from "react";

const Loader = () => {
  return (
    <div className="fixed z-30 inset-0 flex items-center justify-center bg-slate-200/20 backdrop-blur-sm">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
